import styled from 'styled-components';

export const StyledPopupContent = styled.div`
    overflow: hidden;
    padding: 6px 12px;
`;
